export default {
      id: "txt_h1-usage",
      viewBox: "0 0 19 16",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#txt_h1",
      toString: function () {
        return this.url;
      }
    }